import {createContext} from "react"

// We are using TypeScript here to ensure that the contents of the context are clear at any point.
// This both improves IDE-support and ensures that every caller and provider knows exactly what shape the data has.

type AchievementsSummaryContextType = {
    [type: string]: {
        totalProgress: number,
        hasAchieved: Number,
        description: string,
        name: string
    }
}

const AchievementsSummaryContext = createContext<AchievementsSummaryContextType>({});

export default AchievementsSummaryContext;
